
import { getApproveLogs } from '@/api/logs';
const app = {
  namespaced: true,
  state: {
    approveLogs: [],
    viewportHeight: 600,
    searchOrder: '' // 搜索订单号
  },
  actions: {
    // 设置搜索订单号
    setOrder ({ commit }, data) {
      commit('SET_ORDER', data)
    },
    updateViewport({commit}, height) {
      commit('UPDATE_HEIGHT', height);
    },
    getLogs({ commit }, query) {
      return getApproveLogs(query).then(({ data: res }) => {
        if (res.code === 200) {
          commit('UPDATE_LOGS', res.data || []);
        }
      })
    }
  },
  mutations: {
    UPDATE_LOGS: (state, data) => {
      state.approveLogs = data;
    },
    SET_ORDER: (state, data) => {
      state.searchOrder = data
    },
    UPDATE_HEIGHT: (state, height) => {
      state.viewportHeight = height > 600 ? height : 600;
    }
  },
  getters: {
    logs: state => state.approveLogs,
    tableHeight: state => {
      return (state.viewportHeight - 180);
    },
    viewportSize: state => state.viewportHeight
  }
}

export default app
